var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemperatureDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 42,
    viewBox: "0 0 19 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6234 24.1338V4.68075C13.6234 2.63618 11.9609 0.973633 9.91555 0.973633C7.87021 0.973633 6.20844 2.63618 6.20844 4.68075V24.1336C3.12047 25.5735 1.14099 28.6644 1.14099 32.0879C1.14099 36.9258 5.07767 40.8611 9.91555 40.8611C14.7542 40.8611 18.6901 36.9252 18.6901 32.0879C18.6901 28.6644 16.7108 25.5737 13.6234 24.1338ZM17.8269 32.0873C17.8269 36.4496 14.2778 39.9973 9.91555 39.9973C5.55384 39.9973 2.00423 36.4496 2.00423 32.0873C2.00423 28.9155 3.89149 26.059 6.81034 24.811L7.07167 24.6981V4.68075C7.07167 3.11255 8.34735 1.83687 9.91555 1.83687C11.4838 1.83687 12.7594 3.11255 12.7594 4.68075V24.6987L13.0221 24.8116C15.9404 26.059 17.8269 28.9155 17.8269 32.0873Z",
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3476 23.5855C10.3476 23.3476 10.1543 23.1543 9.91564 23.1543C9.67716 23.1543 9.48363 23.3476 9.48363 23.5855V27.2657C7.01888 27.484 5.08667 29.5522 5.08667 32.0732C5.08667 34.7396 7.24844 36.9014 9.91564 36.9014C12.5828 36.9014 14.7446 34.7396 14.7446 32.0732C14.7446 29.5522 12.8124 27.4848 10.3476 27.2657V23.5855V23.5855ZM13.8814 32.0722C13.8814 34.2576 12.1024 36.0372 9.91564 36.0372C7.72888 36.0372 5.95068 34.2582 5.95068 32.0722C5.95068 29.9362 7.6541 28.1987 9.77073 28.1218C9.81723 28.1384 9.8643 28.1503 9.91564 28.1503C9.96698 28.1503 10.0141 28.1384 10.0605 28.1218C12.178 28.1987 13.8814 29.9362 13.8814 32.0722Z",
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.89931,
    y: 6.33949,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.60281
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89931,
    y: 9.54555,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.60281
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89931,
    y: 12.7516,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.60281
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89931,
    y: 15.9577,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.60281
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.89931,
    y: 19.1637,
    width: 3.00631,
    height: 0.60281,
    rx: 0.301405,
    fill: "#616161",
    stroke: "#616161",
    strokeWidth: 0.60281
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemperatureDisable);
export default __webpack_public_path__ + "static/media/iconTemperatureDisable.0077f0e8.svg";
export { ForwardRef as ReactComponent };